import { render } from "./Practice.vue?vue&type=template&id=52d0f046&scoped=true"
import script from "./Practice.vue?vue&type=script&lang=js"
export * from "./Practice.vue?vue&type=script&lang=js"

import "./Practice.vue?vue&type=style&index=0&id=52d0f046&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d0f046"]])

export default __exports__